import { serialize } from "next-mdx-remote/serialize";
import { MDXRemote } from "next-mdx-remote";

import MarkdownLayout from "components/MarkdownLayout";

import { getAllJobs } from "lib/localContent";

import type { GetStaticProps, GetStaticPaths } from "next";
import type { MDXRemoteSerializeResult } from "next-mdx-remote";
import type { Page } from "types/page";
import type { Job } from "lib/localContent";

type PageProps = {
  job: Job;
  mdxSource: MDXRemoteSerializeResult | null;
};

type PageParams = {
  slug: string;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getAllJobs().map(({ slug }) => ({
    params: {
      slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<PageProps, PageParams> = async (context) => {
  if (context.params === undefined) {
    return {
      notFound: true,
    };
  }

  const { slug } = context.params;
  const jobs = getAllJobs();
  const job = jobs.find((s) => s.slug === slug);
  if (job !== undefined) {
    const mdxSource = job.content ? await serialize(job.content) : null;
    return {
      props: {
        job,
        mdxSource,
      },
    };
  }

  return {
    notFound: true,
  };
};

const Job: Page<PageProps> = ({ job, mdxSource }: PageProps) => {
  const { title, desc } = job;

  return (
    <MarkdownLayout
      meta={{
        title,
        desc,
      }}
    >
      {mdxSource ? <MDXRemote {...mdxSource} /> : null}
    </MarkdownLayout>
  );
};

export default Job;
